module.exports = __webpack_public_path__ + "static/media/id-ID.9df3063e.md";